export default __webpack_public_path__ + "static/media/envelope.cbd887d3.svg";